import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import ExtruderPiston from 'features/processFlowDiagrams/svg/shaping-machines/extruder-piston.svg?react'
import ExtruderScrew from 'features/processFlowDiagrams/svg/shaping-machines/extruder-screw.svg?react'
import PelletizingDisc from 'features/processFlowDiagrams/svg/shaping-machines/pelletizing-disc.svg?react'
import PressPiston from 'features/processFlowDiagrams/svg/shaping-machines/press-piston.svg?react'
import PressRoller from 'features/processFlowDiagrams/svg/shaping-machines/press-roller.svg?react'
import ShapingMachineHorizontal from 'features/processFlowDiagrams/svg/shaping-machines/shaping-machine-horizontal.svg?react'
import ShapingMachineVertical from 'features/processFlowDiagrams/svg/shaping-machines/shaping-machine-vertical.svg?react'
import React from 'react'

export const PID_SHAPING_MACHINES_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'extruder-piston',
    name: 'Extruder (Piston)',
    category: 'shaping-machines',
    svgContent: <ExtruderPiston />,
    viewBox: '0 0 110 60',
  },
  {
    id: 'extruder-screw',
    name: 'Extruder (Screw)',
    category: 'shaping-machines',
    svgContent: <ExtruderScrew />,
    viewBox: '0 0 110 60',
  },
  {
    id: 'pelletizing-disc',
    name: 'Pelletizing Disc',
    category: 'shaping-machines',
    svgContent: <PelletizingDisc />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'press-piston',
    name: 'Press (Piston)',
    category: 'shaping-machines',
    svgContent: <PressPiston />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'press-roller',
    name: 'Press (Roller)',
    category: 'shaping-machines',
    svgContent: <PressRoller />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'shaping-machine-horizontal',
    name: 'Shaping Machine (Horizontal)',
    category: 'shaping-machines',
    svgContent: <ShapingMachineHorizontal />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'shaping-machine-vertical',
    name: 'Shaping Machine (Vertical)',
    category: 'shaping-machines',
    svgContent: <ShapingMachineVertical />,
    viewBox: '0 0 100 60',
  },
]
